<template>
    <Form :model="formData" :label-width="80" :rules="formRules" ref="formData">
        <FormItem label="单价" prop="unitPrice">
            <Input v-model="formData.unitPrice" class="item-width" :number="true"></Input>
        </FormItem>
        <FormItem label="收费模式" prop="payType">
            <Select v-model="formData.payType" class="item-width">
                <Option v-for="item in payTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>
        <FormItem label="抄表周期" prop="readCycle" v-if="this.formData.payType === 1">
            <Select v-model="formData.readCycle" class="item-width" :transfer="true">
                <Option v-for="item in readCycleList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>
        <FormItem label="备注">
            <Input v-model="formData.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" class="area-width"></Input>
        </FormItem>
    </Form>
</template>
 
<script type="text/ecmascript-6">
export default {
    props: {
        payTypeList:{
            type:Array,
            default:null
        },
        readCycleList:{
            type:Array,
            default:null
        },
        setings:{
            type:Object,
            default:null
        },
        meterType:{
            type:Number,
            default:null
        }
    },
    watch: {
        setings(val) {
            this.$refs['formData'].resetFields();
            this.formData.unitPrice = val.unitPrice;
            // 水 与 电 设置默认值
            if(val.payType === 0 || val.payType === 1 || val.payType){
                this.formData.payType = val.payType
            }else{
                 this.formData.payType = this.meterType ;
            }
            this.formData.readCycle = val.readCycle;
            this.formData.remark = val.remark;
        }   
    },
    data () {
        const validateUnit = (rule, value, callback) => {
            if(!value){
				callback(new Error('单价不能为空'));
			}
			if(typeof value === 'string'){
				callback(new Error('请输入正确的单价'));
			}
            if(value < 0){
                callback(new Error('单价不能小于0'));
            }
            if(value.toString().split(".").length > 1){
                if(value.toString().split(".")[1].length > 3){
                    callback(new Error('单价保留三位小数'));
                }
            }
            callback();
        }
        return {
            formData:{
                unitPrice:0,
                payType:'',
                readCycle:null,
                remark:''
            },
            formRules:{
                unitPrice:[
                    { required: true, validator: validateUnit, trigger: 'blur', type:'number'}
                ],
                payType:[
                    {required:true, message: '请选择收费模式', trigger: 'change',type:'number' }
                ],
                readCycle:[
                    {required:true, message: '请选择抄表周期', trigger: 'change',type:'number' }
                ]  
            },
        }
    },
    methods: {
        formValidate() {
            let obj = null;
            this.$refs['formData'].validate( bool => {
                if(bool){
                    obj = this.formData;
                }else{
                    obj = false
                }
            })
            return obj
        }
    }
}
</script>
 
<style lang="css" scoped>
.item-width{
    width: 200px;
}
.area-width{
    width: 324px;
}
</style>